<template>
    <div id="VendorPurchaseOrderItemList">
        <div :class="`loader${loaderClass}`" v-show="loading">
        </div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="container-fluid xyz">
                    <div class="page-name">Purchase Order Details
                        <router-link class="btn btn-success waves-effect pull-right" v-bind:to="{name: 'PurchaseOrderAllList'}" >
                            <i class="hi-icon icon-flback"></i>  Back
                        </router-link>

                    </div>

                    <div class="admin-page-content">
                        <div class="purchase-order-item-main internal-container">
                            <div class="container">
                                <div class="customer-view-main col-md-12"> <!--left section-->
                                    <div class="row">
                                        <div class="col-md-4 left-customer-view">
                                            <p>
                                                <span class="customer-detail-rv-title">Purchase Order Number:</span>
                                                <span class="customer-detail-rv">{{poNum}}</span>
                                            </p>
                                            <p>
                                                <span class="customer-detail-rv-title">Purchase Order Type:</span>
                                                <span class="customer-detail-rv">{{po_type}}</span>
                                            </p>
                                            <!-- <div>
                                                <span class="customer-detail-rv-title">From:</span>
                                                <span class="customer-detail-rv">{{from_where}}</span>
                                            </div> -->
                                            <p>
                                                <span class="customer-detail-rv-title">Customer:</span>
                                                <span class="customer-detail-rv">{{customer}}</span>
                                            </p>

                                            <p>
                                                <span class="customer-detail-rv-title">Vendor:</span>
                                                <span class="customer-detail-rv">{{vendor}}</span>
                                            </p>
                                        </div>

                                        <div class="col-md-4 left-customer-view">
                                            <p>
                                                <span class="customer-detail-rv-title">Oredering:</span>
                                                <span class="customer-detail-rv">{{orderingLoc}}</span>
                                            </p>
                                            <p>
                                                <span class="customer-detail-rv-title">Assigned:</span>
                                                <span class="customer-detail-rv">{{assignLoc}}</span>
                                            </p>
                                            <p>
                                                <span class="customer-detail-rv-title">Ship To:</span>
                                                <span class="customer-detail-rv">{{shipToLoc}}</span>
                                            </p>
                                        </div>

                                        <div class="col-md-4 left-customer-view">
                                            <p>
                                                <span class="customer-detail-rv-title">Order Date:</span>
                                                <span class="customer-detail-rv">{{order_date}}</span>
                                            </p>
                                            <p>
                                                <span class="customer-detail-rv-title">Due Date:</span>
                                                <span class="customer-detail-rv">{{due_date}}</span>
                                            </p>
                                            <p>
                                                <span class="customer-detail-rv-title">Delivery Date:</span>
                                                <span class="customer-detail-rv">{{delivery_date}}</span>
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div> <!--left section-->
                        </div>

                        <p>&nbsp;</p>
                        <section class="internal-container purchase-order-btm">
                            <div class="container">

                                <table aria-describedby="table" id="contact_table" class="table table-bordered table-sm font-1 purchase-order-item-table" v-if="purchaseOrderItemsArr != undefined && purchaseOrderItemsArr.length > 0">
                                    <thead class="table-primary">
                                        <tr>
                                            <th v-if="!showItemsColumn">Manufacturer</th>
                                            <th v-if="!showItemsColumn">Asset Model</th>
                                            <th v-if="!showItemsColumn">Asset Pool</th>
                                            <th v-if="!showItemsColumn">Year</th>
                                            <th v-if="showItemsColumn">Part</th>
                                            <th>Quantity</th>
                                            <th>Unit Price</th>
                                            <th>Tax (%)</th>
                                            <th>Amount</th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        <tr v-for="(item, index) in purchaseOrderItemsArr" v-bind:key="index">
                                            <td v-if="!showItemsColumn"> {{ item.manufacturer}} </td>
                                            <td v-if="!showItemsColumn"> {{ item.model}} </td>
                                            <td v-if="!showItemsColumn"> {{ item.vehicle_pool}} </td>
                                            <td v-if="!showItemsColumn"> {{ item.year}} </td>
                                            <td v-if="showItemsColumn"> {{ item.item}} </td>
                                            <td> {{ item.quantity}} </td>
                                            <td> {{ item.unit_price}} </td>
                                            <td> {{ item.tax_percentage}} </td>
                                            <td> {{ item.total}} </td>
                                        </tr>
                                    </tbody>
                                </table>

                                <!--<vue-good-table
                                    ref="listPurchaseOrderItem"
                                    mode="remote"
                                    title="Purchase Order"
                                    @on-page-change="onPageChange"
                                    @on-selected-rows-change="selectionChanged"
                                    @on-column-filter="onColumnFilter"
                                    @on-per-page-change="onPerPageChange"
                                    @on-sort-change="onSortChange"
                                    :totalRows="totalRecords"
                                    :columns="columns"
                                    :rows="rows"
                                    :pagination-options="{
                                        enabled: true,
                                        position: 'both',
                                        perPage: perPage,
                                        dropdownAllowAll: false,
                                    }"

                                    :search-options="{
                                    enabled: false,
                                }">

                            <template slot="table-row" slot-scope="props" v-for="(row,key) in rows">
                                <div :key="key">
                                    <div v-if="props.column.field == 'action'" class='btn-center-vvg'>
                                        <template v-for="(permission, index) in permissions">
                                            <router-link v-if="permission.name == 'add_asset_permit'" title="Edit Asset Type" v-bind:key="'action'+index" class="glyphicon glyphicon-eye-open" v-bind:to="{name: 'PurchaseOrderItemTable',params:{id:props.row.id}}"></router-link>
                                        </template>
                                    </div>
                                    <div v-else>
                                        {{props.formattedRow[props.column.field]}}
                                    </div>
                                </div>
                            </template>

                            <div slot="selected-row-actions">
                                <template  v-for="(permission, index) in permissions">
                                    <button v-bind:key="'delete'+index" v-if="permission.name == 'delete_asset_type'" id="deleteVehicleTypeBtn" v-on:click.prevent="VehiclePermitDelete" class="btn btn-success waves-effect">Delete</button>
                                </template>
                            </div>
                        </vue-good-table>-->
                            </div>
                        </section>

                        <div class="purchase-order-item-right bottom-description-section basic-form-container workorder-view-total-section"> <!--Description section-->
                            <div class="workorder-view-total-section-internal">
                                <div class="row">
                                    <div class="col-xs-12 col-sm-8 col-md-8 col-lg-8 description-left-section">
                                        <!-- <label for="wonotes">Description:</label>
                                        <textarea class="form-control rounded-0" v-model="wonotes" ref="textarea" id="wonotes" rows="6"></textarea> -->
                                    </div>

                                    <div class="workorder-total-section col-xs-12 col-sm-4 col-md-4 col-lg-4">
                                        <label> SUMMARY </label>
                                        <div class="btm-workorder-total-section">
                                            <p>
                                                <span class="order-title"> Unit Price: </span>
                                                <span class="order-des"> {{unitPrice}} </span>
                                            </p>

                                            <p class="background-none">
                                                <span class="order-title"> Tax: </span>
                                                <span class="order-des discount-order-box">
                                                    <div class="input-group">
                                                        <span class="input-group-addon" id="basic-addon4">%</span>
                                                        <input type="text" v-model="tax" id="tax" name="tax" class="vgt-input right-value-fl" style="text-align: right;">
                                                    </div>
                                                $0.00</span>
                                            </p>

                                            <p class="total-workorder">
                                                <span class="order-title"> Total: </span>
                                                <span class="order-des"> {{grandTotal}} </span>
                                            </p>
                                        </div>
                                    </div>

                                </div>
                              </div>
                        </div> <!--Description section-->

                        <!-- <div class="purchase-order-item-right" v-if="listDis">
                                <div class="purchase-order-item-right-main">
                                    <span class="purchase-order-item-title"> Unit Price: </span>
                                    <span class="purchase-order-item-des"> {{unitPrice}} </span>
                                </div>

                                <div class="purchase-order-item-right-main" v-if="!showItemsColumn">
                                    <span class="purchase-order-item-title"> Add Charges: </span>
                                    <span class="purchase-order-item-des"> {{chargesTotal}} </span>
                                </div>

                                <div class="purchase-order-item-right-main">
                                    <span class="purchase-order-item-title"> Tax: </span>
                                    <span class="purchase-order-item-des"> {{taxAmount}} </span>
                                </div>

                                <div class="purchase-order-item-right-main purchase-order-item-total">
                                    <span class="purchase-order-item-title"> Total: </span>
                                    <span class="purchase-order-item-des"> {{grandTotal}} </span>
                                </div>
                        </div> -->

                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="col-md-12">
                    <div class="error-template">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>
    </div>
</template>
<script>

    import Vue from "vue";
    import EventBus from "././event-bus";



    import {commonMixins} from '../mixins/commonMixins';
    import {dataTableMixins} from '../mixins/dataTableMixins';





    export default {
        name: "VendorPurchaseOrderItemList",
        mixins:[commonMixins,dataTableMixins],

        data: () => ({
            firstLoad: 0,
            permissions: [],
            cantAccessPage: "",
            columns: [
                {
                    label: '# PO',
                    field: 'po_no',
                    filterable: true,
                    hidden: false,
                    filterOptions: {
                        enabled: true, // enable filter for this column
                        placeholder: "# PO", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    },
                    // sortable:false
                },
                {
                    label: 'Part',
                    field: 'item',
                    filterable: true,
                    hidden: false,
                    filterOptions: {
                        enabled: true, // enable filter for this column
                        placeholder: "Part", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    },
                    // sortable:false
                },
                {
                    label: 'Manufacturer',
                    field: 'manufacturer',
                    filterable: true,
                    hidden: false,
                    filterOptions: {
                        enabled: true, // enable filter for this column
                        placeholder: "Manufacturer", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    },
                    // sortable:false
                },
                {
                    label: 'Asset Model',
                    field: 'model',
                    filterable: true,
                    hidden: false,
                    filterOptions: {
                        enabled: true, // enable filter for this column
                        placeholder: "Asset Model", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    },
                    // sortable:false
                },
                {
                    label: 'Year',
                    field: 'year',
                    filterable: true,
                    hidden: false,
                    filterOptions: {
                        enabled: true, // enable filter for this column
                        placeholder: "Year", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    },
                    // sortable:false
                },
                {
                    label: 'Quantity',
                    field: 'quantity',
                    filterable: true,
                    hidden: false,
                    filterOptions: {
                        enabled: true, // enable filter for this column
                        placeholder: "Quantity", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    },
                    // sortable:false
                },
                {
                    label: 'Unit Price',
                    field: 'unit_price',
                    type: 'number',
                    filterable: true,
                    hidden: false,
                    filterOptions: {
                        enabled: true, // enable filter for this column
                        placeholder: "Unit Price", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    },
                    // sortable:false
                },
                {
                    label: 'Asset Pool',
                    field: 'vehicle_pool',
                    filterable: true,
                    hidden: false,
                    filterOptions: {
                        enabled: true, // enable filter for this column
                        placeholder: "Asset Pool", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    },
                    // sortable:false
                },

            ],
            rows: [],
            totalRecords: 0,
            serverParams: {
                columnFilters: {},
                sort: {
                    field: 'id',
                    type: 'desc',
                },
                page: 1,
                perPage: 50
            },
            asset_value: false,
            loading:false,
            permit_value:false,
            addPermit:false,
            assetId:"",
            selectedFile:"",
            poId:"",
            poNum:"",
            vendor:"",
            orderingLoc:"",
            assignLoc:"",
            shipToLoc:"",
            unitPrice:0,
            taxAmount:0,
            chargesTotal:0,
            taxTotal:0,
            delivery_date:"",
            order_date:"",
            due_date:"",
            po_type:"",
            customer:"",
            from_where:"",
            listDis:true,
            grandTotal:0,
            purchaseOrderItemsArr:[],
            showItemsColumn:true
        }),
        watch: {
            //check permission change
            permissions: function (permissions) {
                var self = this;
                if (permissions.length > 0) {
                    for (var i = 0; i < permissions.length; i++) {
                        if (permissions[i].name == 'view_purchase_order') {
                            self.cantAccessPage = true;
                        }
                    }
                }

            }
        },
        created: function() {

        },

        mounted: function() {
            var self = this;


            self.getPermissions();
            self.getPoInfo();
            self.loadList();

        },
        methods: {

        selectionChanged(param) {
                var self = this;
                if(param.selectedRows.length == 100) {
                  EventBus.$emit('clear-selection', false);
                } else {
                  EventBus.$emit('clear-all-flags', false);
                }
                // console.log(self.computed.selectedRows);
                // var rowData = self.$refs['my-table'].selectedRows;
                // console.log(rowData);
            },

        getPoInfo(){

            var self = this;
            var path = window.location.pathname;
            var po = path.split("/");

            $.ajax({
                    url: process.env.ROOT_API + "/vendor-purchase-order/"+po[2],
                    type: "POST",
                    headers: this.ajxHeaders,
                    dataType: "json",
                    success: function (data) {
                        self.loading = false;
                        if (data.status == "success") {

                            self.poNum = data.content.po_no;
                            self.po_type = data.content.type;
                            self.from_where = data.content.from_where;
                            if(data.content.type == "Item"){
                                self.showItemsColumn = true;
                                self.$set(self.columns[2], 'hidden', true);
                                self.$set(self.columns[3], 'hidden', true);
                                self.$set(self.columns[4], 'hidden', true);
                                self.$set(self.columns[7], 'hidden', true);
                            }else{
                                self.showItemsColumn = false;
                                self.$set(self.columns[1], 'hidden', true);
                            }
                            if(data.content.cusName != null){
                                self.customer = data.content.cusName+" ("+data.content.cusCode+")";
                            }else{
                                self.customer = "-"
                            }
                            if(data.content.vendorName != null){
                                self.vendor = data.content.vendorName+" ("+data.content.vendorCode+")";
                            }else{
                                self.vendor = "-"
                            }
                            self.orderingLoc = data.content.order_location+" ("+data.content.orderLocCode+")";
                            self.assignLoc = data.content.assigned_location+" ("+data.content.assignLocCode	+")";
                            self.shipToLoc = data.content.shop_location+" ("+data.content.shipLocCode+")";
                            if(data.content.chargesTotal){
                                self.chargesTotal = data.content.chargesTotal;
                            }
                            if(data.content.taxTotal){
                                self.taxTotal = data.content.taxTotal;
                            }
                            self.delivery_date = data.content.delivery_date;
                            self.order_date = data.content.order_date;
                            self.due_date = data.content.due_date;
                            self.unitPrice = data.content.unit_total;
                            self.taxAmount = data.content.tax_total;
                            self.grandTotal = data.content.grand_total;
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        if (jqXHR.status == 0) {
                            self.errorMsg = "Remote server cannot be reached";
                        } else {
                            //redirect to login page if user not authenticated
                            if (jqXHR.status == 401) {
                                //clear previous data
                                localStorage.removeItem("user_obj");
                                localStorage.removeItem("tkn");

                                self.$router.push("/");
                            }
                            self.error = jqXHR.responseJSON.message;
                        }
                    }
                });
        },

        loadList() {

            var self = this;

            var path = window.location.pathname;
            var po = path.split("/");
            self.poId = po[2];

            self.loading = true;
            var fields = {
                page: self.serverParams.page,
                perPage: self.serverParams.perPage,
                filters: self.serverParams.columnFilters,
                sort: self.serverParams.sort,
                poId:self.poId
            };
            self.firstLoad = 1;
            $.ajax({
                url: process.env.ROOT_API + "/purchase_order_item/list",
                type: "POST",
                data: fields,
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {
                    self.loading = false;
                    if (data.status == "success") {
                        self.rows = data.content.row;
                        self.totalRecords = data.content.totalRecords;
                        self.purchaseOrderItemsArr = data.content.row;

                        if(data.content.totalRecords == 0){
                            self.listDis = false;
                        }
                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    if (jqXHR.status == 0) {
                        self.errorMsg = "Remote server cannot be reached";
                    } else {
                        //redirect to login page if user not authenticated
                        if (jqXHR.status == 401) {
                            //clear previous data
                            localStorage.removeItem("user_obj");
                            localStorage.removeItem("tkn");

                            self.$router.push("/");
                        }
                        self.error = jqXHR.responseJSON.message;
                    }
                }
            });
        },
    }
};
</script>



// WEBPACK FOOTER //
// src/components/VendorPurchaseOrderItemList.vue